package one.healthium.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.SubcomposeLayout
import androidx.compose.ui.unit.Dp
import kotlin.math.max

@Composable
fun MeasureMaxHeight(
    modifier: Modifier = Modifier,
    viewToMeasure: @Composable (Int) -> Unit,
    measureCount: Int = 1,
    content: @Composable (Dp) -> Unit,
) {
    var cachedHeight by remember { mutableStateOf<Dp?>(null) }

    val cached = cachedHeight
    if (cached != null) {
        content(cached)
    } else {
        SubcomposeLayout(modifier = modifier) { constraints ->
            val measuredMaxHeight = (0..<measureCount).fold(0) { maxHeight, index ->
                val measuredHeight = subcompose("viewToMeasure:$index") {
                    viewToMeasure(index)
                }[0].measure(constraints).height
                max(maxHeight, measuredHeight)
            }

            val height = measuredMaxHeight.toDp()
            cachedHeight = height

            val contentPlaceable = subcompose("content") {
                content(height)
            }.firstOrNull()?.measure(constraints)

            layout(contentPlaceable?.width ?: 0, contentPlaceable?.height ?: 0) {
                contentPlaceable?.place(0, 0)
            }
        }
    }
}
